import { LocalDate, DateTimeFormatter, nativeJs } from "@js-joda/core";

import {
    declareAiCapability,
    provideAiCapability,
} from "@medflyt/webapp-react/src/modules/ai-omnibar/ai-capability-registry";

// Engagement KPI describing its one filter: the range it reports over.
declareAiCapability({
    id: "engagementKpi.filter",
    title: "Set the engagement KPI date range",
    effect: "prefill",
    description:
        "Sets the date range on Agencies > Engagement kpi and re-runs it. The page opens on the last month. Only works while that page is open.",
    location: "the date range of the Agencies > Engagement kpi page",
    scope: "page",
    permissionKey: "view_agencies_section",
    params: [
        { name: "from", type: "date", required: false, description: "First day to include, as yyyy-MM-dd." },
        { name: "to", type: "date", required: false, description: "Last day to include, as yyyy-MM-dd." }
    ],
    examples: ["engagement kpi for last quarter", "engagement kpi this month"]
});

//! @ngInject
export function engagementKPICtrl($scope, DatabaseApi, toaster, NgTableParams) {
    $scope.from = new Date(LocalDate.now().minusMonths(1).format(DateTimeFormatter.ofPattern("MM/dd/yyyy")));
    $scope.to = new Date(LocalDate.now().format(DateTimeFormatter.ofPattern("MM/dd/yyyy")));

    $scope.engagementKPIFilters = {
        isTriggered: true
    };

    const engagementKPIFilterByMethods = {
        kpiIsTriggered: (kpiTrigger, isTriggered) => kpiTrigger.isTriggered === isTriggered,
    };

    function filterKPITriggersTable() {
        if (!$scope.triggers) return;
        let filters = [];

        const isTriggered = $scope.engagementKPIFilters.isTriggered;
        if (isTriggered === true) {
            filters.push(function (trigger) { return engagementKPIFilterByMethods.kpiIsTriggered(trigger, isTriggered); });
        }

        let filteredTriggers = $scope.triggers;
        if (filters.length > 0) {
            filteredTriggers = filteredTriggers.filter(function (kpiTrigger) {
                let isFiltered = true;
                for (let idx = 0; isFiltered && idx < filters.length; idx++) {
                    isFiltered = isFiltered && filters[idx](kpiTrigger);
                }
                return isFiltered;
            });
        }

        initKPITriggersTable(filteredTriggers);
    }

    function initKPITriggersTable(items) {
        const options = {
            count: 25
        };
        $scope.engagementKPITable = new NgTableParams(options, {
            counts: [],
            dataset: items
        });
    }


    const releaseEngagementKpiFilter = provideAiCapability("engagementKpi.filter", (args) => {
        const asDate = (text) => {
            const parts = String(text).split("-").map(Number);

            if (parts.length !== 3 || parts.some(isNaN)) {
                throw new Error("Could not read the date " + text + ".");
            }

            return new Date(parts[0], parts[1] - 1, parts[2]);
        };

        if (args.from !== undefined) {
            $scope.from = asDate(args.from);
        }

        if (args.to !== undefined) {
            $scope.to = asDate(args.to);
        }

        $scope.getKPITriggers();

        const range = [args.from, args.to].filter(Boolean).join(" to ");

        return range === "" ? "Re-ran the engagement KPI" : "Showing engagement KPI " + range;
    });

    $scope.$on("$destroy", releaseEngagementKpiFilter);

    $scope.getKPITriggers = () => {
        let url = 'admin/customer-engagement/kpi';
        const fromParam = LocalDate.from(nativeJs($scope.from));
        const toParam = LocalDate.from(nativeJs($scope.to));
        url = `${url}?from=${fromParam}&to=${toParam}`;

        DatabaseApi.get(url).then(function (res) {
            $scope.triggers = res.data.triggers;
            filterKPITriggersTable();
        }, function (err) {
            toaster.pop('error', 'Something went wrong', 'could not get KPI triggers');
        });
    }

    $scope.updateKPITrigger = (kpiTrigger, fieldName) => {
        let url = `admin/customer-engagement/kpi/${kpiTrigger.id}`;

        let body = {};
        body[fieldName] = kpiTrigger[fieldName];

        DatabaseApi.patch(url, body).then(function (res) {
            toaster.pop('success', "KPI Trigger updated successfully");
        }, function (err) {
            toaster.pop('error', "Something went wrong", "Could not update KPI Trigger");
        });
    }

    $scope.$watch('engagementKPIFilters', function () {
        filterKPITriggersTable();
    }, true);

    $scope.getKPITriggers();
};